/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum version_games {
  NINTH_AGE = 'ninthAge',
  BATTLE = 'battle',
  ESSENCE_OF_WAR = 'essenceOfWar',
  THE_OLD_WORLD = 'theOldWorld',
}
